import { Page } from "@irvin-group/airtable-data-types";

interface PageWithChildren extends Page {
  children: ReadonlyArray<Page>
}

export const nestPages = (pages: ReadonlyArray<Page>): ReadonlyArray<PageWithChildren> => {
  return pages
    .map(p => {
      const out: PageWithChildren = {
        ...p,
        children: pages.filter(q => q.meta.Parent === p.meta.Slug)
      };
      return out;
    })
    .filter(p => !p.meta.Parent)
    .filter(p => !p.meta.HideInNav);
};